import { render } from "./SeccionProdsDestacar.vue?vue&type=template&id=2090bfb2&scoped=true"
import script from "./SeccionProdsDestacar.vue?vue&type=script&lang=js"
export * from "./SeccionProdsDestacar.vue?vue&type=script&lang=js"

import "./SeccionProdsDestacar.vue?vue&type=style&index=0&id=2090bfb2&scoped=true&lang=css"

import exportComponent from "C:\\paginascedis\\general\\cedispage2.0_general_cecra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2090bfb2"]])

export default __exports__